// extracted by mini-css-extract-plugin
module.exports = {"buttonRow":"src-JobPage-___JobPage-module__buttonRow___37hQd","labelFormat":"src-JobPage-___JobPage-module__labelFormat___1R1_H"};